export default function ReviewSection() {
  return (
    <section id="review" className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            Honest Review
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Sugargoo Review 2026: Is Sugargoo Legit?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            An honest, detailed look at what makes this shopping agent stand out — and what you should know before using it.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-thumb-up-line text-accent-700 text-sm"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900">Pros</h3>
            </div>
            <ul className="space-y-3">
              {[
                'Affordable and reliable shopping agent service',
                'Large marketplace support with wide product selection',
                'Quality QC photo service for purchase verification',
                'Efficient warehouse management and consolidation',
                'Multiple international shipping options available',
                'Active community with shared finds and reviews',
              ].map((pro) => (
                <li key={pro} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-accent-600 mt-0.5 text-sm flex-shrink-0"></i>
                  <span>{pro}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200">
                <i className="ri-information-line text-secondary-700 text-sm"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900">Things to Know</h3>
            </div>
            <ul className="space-y-3">
              {[
                'Shipping costs vary based on weight and destination',
                'Some learning curve for first-time international buyers',
                'Exchange rates may affect final purchase prices',
                'Processing times differ between different marketplaces',
              ].map((con) => (
                <li key={con} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <i className="ri-error-warning-line text-secondary-600 mt-0.5 text-sm flex-shrink-0"></i>
                  <span>{con}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-200/50">
                <th className="text-left px-5 py-3 font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                <th className="text-left px-5 py-3 font-semibold text-primary-700 whitespace-nowrap">Sugargoo</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Warehouse Service', 'Yes — Full Support'],
                ['QC Photos', 'Yes — High Quality'],
                ['Shipping Options', 'Multiple Methods'],
                ['Beginner Friendly', 'Medium — Learning Needed'],
                ['International Users', 'Yes — Worldwide'],
                ['Community Support', 'Active & Growing'],
              ].map(([feature, value]) => (
                <tr key={feature} className="border-t border-background-200/50">
                  <td className="px-5 py-2.5 text-foreground-700 font-medium whitespace-nowrap">{feature}</td>
                  <td className="px-5 py-2.5 text-primary-700 font-semibold whitespace-nowrap">{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}